import React from "react";
import { Grid } from "Components/Base/Layout";
import { Paper } from "Components/Base/Surfaces/Paper";
import ToolbarMobile from "./ToolbarMobile";
import FilterMobile from "./Filter/FilterMobile";
import CourseList from "./CourseList";
import StateRenderer from "./StateRenderer";

const MobileLayout = ({ state, languageContext, resetFilters }) => {
  return (
    <Grid container spacing={2} alignItems="flex-start">
      <Grid item xs={12}>
        <Paper
          elevation={0}
          square
          sx={{
            padding: "0 !important",
          }}
        >
          <ToolbarMobile languageContext={languageContext} />
          <FilterMobile languageContext={languageContext} />
          <StateRenderer
            state={state}
            languageContext={languageContext}
            resetFilters={resetFilters}
          />
          <CourseList languageContext={languageContext} />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default MobileLayout;
